import { Box, CircularProgress, Typography } from "@mui/joy";
import { Container } from "@mui/material";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { Image } from "react-bootstrap";
import { useTranslation } from "react-i18next";

export const datatable_style = {
  table: {
    style: {
      backgroundColor: "#FFFFFF",
      borderRadius: "16px",
    },
  },
  headRow: {
    style: {
      backgroundColor: "#f8f9fa",
      borderBottom: "1px solid grey",
      borderRadius: "16px 16px 0 0",
      minHeight: "52px",
    },
  },
  headCells: {
    style: {
      fontSize: "0.875rem",
      fontWeight: "600",
      color: "#1a1a1a",
      paddingLeft: "16px",
      paddingRight: "16px",
      backgroundColor: "#f8f9fa",
      whiteSpace: "nowrap",
      overflow: "visible",
      textOverflow: "unset",
    },
  },
  cells: {
    style: {
      fontSize: "0.875rem",
      paddingLeft: "16px",
      paddingRight: "16px",
      paddingTop: "12px",
      paddingBottom: "12px",
      borderBottom: "1px solid #e0e0e0",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
  },
  rows: {
    style: {
      minHeight: "60px",
      "&:hover": {
        backgroundColor: "#f5f5f5",
        cursor: "pointer",
      },
    },
    stripedStyle: {
      backgroundColor: "#fafafa",
    },
  },
  pagination: {
    style: {
      borderTop: "1px solid #e0e0e0",
      minHeight: "56px",
    },
    pageButtonsStyle: {
      borderRadius: "4px",
      height: "32px",
      padding: "0 8px",
      margin: "0 2px",
      cursor: "pointer",
      transition: "all 0.2s",
      backgroundColor: "transparent",
      border: "1px solid #e0e0e0",
      "&:hover": {
        backgroundColor: "#e0e0e0",
        color: "white",
      },
    },
  },
  responsiveWrapper: {
    style: {
      minHeight: "400px",
      overflowX: "auto",
    },
  },
};

export const LoadingComponent = () => {
  const { t } = useTranslation();
  return (
    <Box className="loading-container">
      <CircularProgress size="sm" className="loading-spinner" />
      <Typography level="body-sm" className="loading-text">
        {t("common_loading")}
      </Typography>
    </Box>
  );
};

export const NoDataComponent = () => {
  const { t } = useTranslation();
  return (
    <Box className="no-data-container flex-column align-items-center justify-content-center">
      <Container className="img-fluid my-5">
        <img src="/images/no-data.png" alt="No data" width={100} />
      </Container>
      <Typography level="body-sm" color="neutral">
        {t("common_no_data")}
      </Typography>
    </Box>
  );
};

const autoTableOptions = (head, body) => {
  return {
    head: [head],
    body: body,
    styles: { fontSize: 8 },
    headStyles: { fillColor: [255, 204, 0], textColor: [0, 0, 0] },
    startY: 10,
  };
};

export const downloadTablePdf = (column, rows, filename) => {
  const doc = new jsPDF();
  const tableColumn = column.map((col) => col.title);
  const tableRows = rows.map((row) =>
    column.map((col) => {
      const key = col.data;
      return row[key] !== undefined && row[key] !== null ? row[key] : "";
    })
  );

  autoTable(doc, autoTableOptions(tableColumn, tableRows));

  doc.save(filename + ".pdf");
};

export function exportToCsv(array, filename = "data") {
  const csv = convertArrayOfObjectsToCSV(array);
  if (!csv) return;

  const csvData = `data:text/csv;charset=utf-8,${encodeURIComponent(csv)}`;

  const link = document.createElement("a");
  link.setAttribute("href", csvData);
  link.setAttribute("download", filename + ".csv");

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

function convertArrayOfObjectsToCSV(array) {
  if (!array || !array.length) return null;

  const columnDelimiter = ",";
  const lineDelimiter = "\r\n";
  const keys = Object.keys(array[0]);

  let result = "";
  result += keys.join(columnDelimiter);
  result += lineDelimiter;

  array.forEach((item) => {
    let ctr = 0;
    keys.forEach((key) => {
      if (ctr > 0) result += columnDelimiter;

      result += escapeCSVField(item[key]);

      ctr++;
    });
    result += lineDelimiter;
  });

  return result;
}

function escapeCSVField(field) {
  if (field === null || field === undefined) return "";

  let str = String(field);

  str = str.replace(/"/g, '""');

  if (/[",\r\n#]/.test(str)) {
    return `"${str}"`;
  }

  return str;
}
